export default __webpack_public_path__ + "static/media/ketocheatday@2x.300e7e4f.jpg";